<template>
  <div>
    <div v-if="error" class="form-error">
      <!-- eslint-disable vue/html-indent -->
      <!-- Need to format it like this due to "white-space: pre" on the form-error -->
      <span v-if="error.message.includes('PasswordStrengthError')">Password is too weak
* At least 8 characters in length
* Should contain:
* lower case letters (a-z)
* upper case letters (A-Z)
* numbers (i.e. 0-9)</span>
      <span v-else>
        {{ error.message || error.error }}
      </span>
    </div>
    <md-progress-bar v-if="processing" md-mode="query" />
    <div>
      <div v-if="success">Password changed successfully</div>
    </div>
    <label class="blue-6 color">Old Password</label>
    <md-field>
      <md-input v-model="state.oldPassword" type="password" />
    </md-field>
    <label class="blue-6 color">New Password</label>
    <md-field>
      <md-input v-model="state.newPassword" type="password" />
    </md-field>
    <label class="blue-6 color">Confirm New Password</label>
    <md-field>
      <md-input v-model="state.confirmPassword" type="password" />
    </md-field>
    <div v-if="state.validationError" class="form-error">{{ state.validationError }}</div>
    <div class="md-layout md-alignment-center-right">
      <md-button class="md-raised md-primary" @click="changePassword">Change Password</md-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'change-password-form',
  props: {
    processing: {
      type: Boolean,
    },
    success: {
      type: Boolean,
    },
    error: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    state: {
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
      validationError: null,
    }
  }),
  watch: {
    processing(newVal, oldVal) {
      if (oldVal === true && newVal === false && !this.error) {
        this.state.oldPassword = '';
        this.state.newPassword = '';
        this.state.confirmPassword = '';
      }
    }
  },
  methods: {
    changePassword() {
      this.state.validationError = null;
      if (!this.state.oldPassword || !this.state.newPassword || !this.state.confirmPassword) {
        this.state.validationError = 'One or more fields is missing!'
        return;
      }
      if (this.state.newPassword !== this.state.confirmPassword) {
        this.state.validationError = 'Passwords do not match!'
        return;
      }
      this.$emit('changePassword', this.state.oldPassword, this.state.newPassword);
      this.$analytics.event('Account', 'change_password');
    },
  },
};
</script>

<style scoped>
</style>
